import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Flex, Text, useDisclosure } from '@chakra-ui/react';

import { columns, data } from './data';
import AddPayment from './AddPayment';
import ViewPayment from './ViewPayment';
import Table from '../../components/table';
import Topbar from '../../components/topbar';
import Searchbar from '../../components/searchbar';
import CustomSelect from '../../components/select';
import MainLayout from '../../components/mainlayout';
import useGetPayments from '../../api/queries/useGetPayments';
import useGetBalance from '../../api/queries/useGetBalance';
import { useUserContext } from '../../contexts/userContexts';
import { SORT_NEWEST_FIRST } from '../../utils/constants';

const Payments = () => {
  const {
    isOpen: isAddPaymentOpen,
    onOpen: onAddPaymentOpen,
    onClose: onAddPaymentClose,
  } = useDisclosure();
  const {
    isOpen: isViewPaymentOpen,
    onOpen: onViewPaymentOpen,
    onClose: onViewPaymentClose,
  } = useDisclosure();
  const [productsData, setProductsData] = useState([]);
  const paymentsQuery = useGetPayments();
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [sortOrder, setSortOrder] = useState(SORT_NEWEST_FIRST);
  const [search, setSearch] = useState('');
  const { user } = useUserContext();

  const sorted = useMemo(() => {
    const raw = paymentsQuery?.data || [];
  
    // Filter first
    const filtered = raw.filter(tx => {
      if (!search) return true; // No search -> keep all
      const fullName = `${tx.payee_id?.first_name || ''} ${tx.payee_id?.surname || ''}`.toLowerCase();
      return fullName.includes(search.toLowerCase());
    });
  
    // Then sort
    const result = [...filtered].sort((a, b) => {
      const dateA = new Date(a?.date_created);
      const dateB = new Date(b?.date_created);
  
      if (sortOrder === SORT_NEWEST_FIRST) {
        return dateB - dateA; // Newest first
      } else {
        return dateA - dateB; // Oldest first
      }
    });
  
    console.log('Filtered + Sorted result:', result.map(tx => ({
      name: `${tx.payee_id?.first_name} ${tx.payee_id?.surname}`,
      date: tx.date_created
    })));
  
    return result;
  }, [paymentsQuery?.data, sortOrder, search]);
  
  // Update state whenever sorted changes
  useEffect(() => {
    setProductsData(sorted);
  }, [sorted]);
  

  // const sellerId = user?.info?._id;
  // console.log("🧠 Seller ID:", sellerId);

  // const balanceQuery = useGetBalance(sellerId);
  console.log('💰 paymentsQuery Query:', paymentsQuery);

  return (
    <MainLayout h={'100%'} minH={'100vh'} paddingBottom={20}>
      <Box>
        <Topbar title={'PAYMENTS'} />
        <Flex
          bg={'#f8fbff'}
          padding={8}
          height={'100%'}
          gap={2}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Flex align={'center'}>
            <Searchbar onChange={setSearch} title={'Search'} />
          </Flex>
          <Flex justify={'space-between'} alignItems={'center'}>
            <Flex gap={3}>
              <CustomSelect
                label={'Sort'}
                onChange={setSortOrder}
                style={{ maxWidth: '200px' }}
                inputStyle={{
                  border: 'none',
                  background: '#fff',
                  color: '#898989',
                  fontSize: '14px',
                  fontFamily: 'PlusJakartaSansMedium',
                }}
              >
                <option value={'newest'}>Newest First</option>
                <option value={'oldest'}>Oldest First</option>
              </CustomSelect>
              <Button
                onClick={() => onAddPaymentOpen()}
                w={'129px'}
                py={6}
                bg={'#456EFF'}
                borderRadius={'8px'}
                color={'white'}
                textTransform={'capitalize'}
                alignSelf={'flex-end'}
                alignItems={'center'}
                justifyContent={'center'}
                fontSize={'12px'}
                fontFamily={'PlusJakartaSansBold'}
              >
                Add Payment
              </Button>
            </Flex>
          </Flex>
        </Flex>
        <Box
          minW={'100%'}
          w={'1px'}
          overflowX={'auto'}
          p={8}
          pt={0}
          bg={'#f8fbff'}
        >
          {paymentsQuery.isLoading ? (
            <Text fontSize="lg">Loading Payments...</Text>
          ) : (
            <Table
              data={productsData}
              columns={columns({
                onViewPaymentOpen: row => {
                  setSelectedPayment(row);
                  onViewPaymentOpen();
                },
              })}
            />
          )}
        </Box>
        <AddPayment isOpen={isAddPaymentOpen} onClose={onAddPaymentClose} />
        <ViewPayment
          isOpen={isViewPaymentOpen}
          onClose={onViewPaymentClose}
          payment={selectedPayment}
        />
      </Box>
    </MainLayout>
  );
};
export default Payments;
